import { useContext } from "react";
import { ViewTransitionContext } from "@/context/ViewTransitionContext";

export const useViewTransition = () => {
    const context = useContext(ViewTransitionContext);
    
    if (!context) {
      throw new Error('useViewTransition must be used within a ViewTransitionProvider');
    }
    
    return context;
  };